import axios from "axios";

//add customer
export const getEmiCalc = () => {
  return axios
    .get("/emi-calc/")
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response.data;
    });
};
